import { render, staticRenderFns } from "./TradesTable.vue?vue&type=template&id=5c4239b3&scoped=true&"
import script from "./TradesTable.vue?vue&type=script&lang=js&"
export * from "./TradesTable.vue?vue&type=script&lang=js&"
import style0 from "./TradesTable.vue?vue&type=style&index=0&id=5c4239b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4239b3",
  null
  
)

export default component.exports